﻿import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Callout, Intent } from "@blueprintjs/core";
import { Button } from "components/buttons";
import { ShowHide } from "components/layout";
import PropTypes from 'prop-types';
import './Notifications.css';

const defaultFunction = () => { };

export function NotificationInline(
    {
        intent = "",
        allowClose = true,
        text = "",
        show = false,
        messages = [],
        isShort = false,
        withIcon = true,
        icon = null,
        isBanner = false,
        additionalStyle = {},
        onClose = defaultFunction
    }
) {
    const [intentValue, setIntent] = useState(Intent.NONE);
    const [iconValue, setIcon] = useState(null);
    const [showValue, setShow] = useState(false);

    useEffect(() => {
        if (intent) {
            switch (intent.toLowerCase()) {
                case "warning":
                    setIntent(Intent.WARNING);
                    setIcon("warning-sign");
                    break;
                case "info":
                case "primary":
                    setIntent(Intent.PRIMARY);
                    setIcon("notifications");
                    break;
                case "danger":
                    setIntent(Intent.DANGER);
                    setIcon("error");
                    break;
                case "success":
                    setIntent(Intent.SUCCESS);
                    setIcon("tick-circle");
                    break;
                default:
                    setIntent(Intent.NONE);
                    setIcon(null);
                    break;
            }
        }

        if(iconValue != null) {
            setIcon(icon);
        }

    }, [intent, icon]);

    useEffect(() => {
        setShow(show || false);
    }, [show]);

    function closeNotification() {
        setShow(false);
        onClose();
    }

    return (
        <ShowHide
            evaluator={showValue}
            show={(
                <Callout className={classNames("notification-inline", {"notification-inline-no-margin": isBanner }, 
                                                { "closable": allowClose, "short-width": isShort })}
                    intent={intentValue}
                    icon={withIcon ? iconValue : null}
                    style={additionalStyle}
                >
                    {messages.map(x => <div key={x.message}>{x.message}</div>)}
                    {text}
                    <ShowHide
                        evaluator={allowClose}
                        show={(
                            <Button icon="cross" minimal={true} className="btn-close" onClick={closeNotification}></Button>
                        )}
                    />
                </Callout>
            )}
        ></ShowHide>
    );
}

NotificationInline.propTypes = {
    intent: PropTypes.string, 
    show: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    allowClose: PropTypes.bool,
    messages: PropTypes.array,
    isShort: PropTypes.bool,
    withIcon: PropTypes.bool,
    icon: PropTypes.string,
    isBanner: PropTypes.bool,
    additionalStyle: PropTypes.object,
    onClose: PropTypes.func
};